var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
var outlineBase = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline-color: transparent;\n  outline-offset: ", ";\n  outline-style: ", ";\n  outline-width: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.outline.offset, "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.outline.style;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.outline.width, "px");
});
export { outlineBase };